import React from 'react'
import { Text } from 'react-native'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../../assets/icons'
import { paths } from '../../../../links'
import { useInvoiceDetailsContext } from '../../../TabInvoice/InvoiceDetailsContext'
import { useStore } from '../../../../../store'
import { useTranslation } from 'react-i18next'
import { ApplicationType } from '@linqpal/models/src/dictionaries/applicationType'

export const LoanAppliedSuccessPrompt = ({ navigation }) => {
  const { setInvoicePaymentMessage, invoicePaymentMessage } =
    useInvoiceDetailsContext()

  const { userStore } = useStore()
  const { t } = useTranslation('global')

  return (
    <SuccessFailurePrompt
      visible={invoicePaymentMessage}
      icon={<PromptSuccessIcon />}
      title={t(
        'CreditApplication.submit-success-messages.with-invoice-previously-approved.title',
      )}
      message={
        <Text>
          {t(
            'CreditApplication.submit-success-messages.with-invoice-previously-approved.message',
          )}
        </Text>
      }
      exitable={false}
      buttonData={{
        title: 'Ok, got it',
        contentStyle: { width: '100%' },
        style: { width: '90%' },
        onPress: () => {
          setInvoicePaymentMessage(false)
          userStore.fetchDocument(ApplicationType.Credit)
          navigation.navigate(paths.Console._self)
        },
      }}
      textContentBottomMargin={20}
    />
  )
}
